export default [
  {
    name: 'Airsoft',
    children: [
      {
        name: 'Über uns',
        route: 'airsoft',
      },
      {
        name: 'Spielergalerie',
        route: 'airsoftPlayers',
      },
      {
        name: 'Guides',
        route: 'airsoftGuides',
      },
      {
        name: 'Spielfeld: MudTrack',
        href: 'https://mudtrack.allesimrudel.de/',
        external: 'https://mudtrack.allesimrudel.de/',
      }
    ]
  },
  {
    name: 'Gaming',
    route: 'gaming'
  },
  {
    name: 'Beitritt',
    route: 'join'
  },
];
